import { ArticleModel } from '@/types/api'
import { baseApi } from './baseApi'

export const categoryHighlightApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategoryHighlight: builder.query<ArticleModel[], number>({
      query: (productGroup) => `CategoryHighlight?productGroupId=${productGroup}`,
      keepUnusedDataFor: 1800,
    }),
  }),
})

export const { useGetCategoryHighlightQuery, util: { getRunningQueriesThunk } } = categoryHighlightApi
export const { getCategoryHighlight } = categoryHighlightApi.endpoints